<template>
    <div class="wrap">
<!--    <div class="bottom-action-bar">-->
        <action-bar class="action-bar"/>
        <!-- 动作按钮 -->
        <div class="action_button">
            <van-button :style="{height:'6vh'}" type="primary" round @click="onBtnClick">{{btnText}}</van-button>
        </div>

<!--    </div>-->
    </div>
</template>

<script>
import ActionBar from "../actionBar";
export default {
    name: "BottomActionBar",
    components:{ActionBar},
    props:{
        btnText:{
            type:String,
            default:"查看详情",
        }
    },
    methods:{
        // 抛出点击事件
        onBtnClick(){
            this.$emit('btn-click')
        }
    }
}
</script>

<style scoped>
.wrap{
    width:100vw;
    height: 9vh;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    position: fixed;
    bottom: 0;
    background-color: #FFF;
    box-shadow: 0 1px 10px 2px rgba(56,56,56,0.15);
}
.bottom-action-bar{
    position: fixed;
    width:100vw;
    height: 8vh;
    box-sizing: border-box;
    display: flex;
    justify-content: space-around;
    align-items: center;
    box-shadow: -4px 0 30px 8px rgba(71, 71, 71, 0.08);
}
.action-bar{
    width: 60%;
    height:8vh;
    box-sizing: border-box;
}
.action_button{
    width:30%;
    height:8vh;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;

}

</style>
